import { SelectOption } from "@/common/FormTools";

export const MONTHS_OFFERED = 12;

export type MonthRange = {
  dateFrom: string;
  dateTo: string;
};

const MONTH_LABELS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const pad = (value: number): string => String(value).padStart(2, "0");

// The backend parses DD.MM.YYYY, the same format the parcels list already sends.
const format = (date: Date): string =>
  `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}`;

export const monthRange = (year: number, month: number): MonthRange => ({
  dateFrom: format(new Date(year, month, 1)),
  // Day 0 of the next month is the last day of this one.
  dateTo: format(new Date(year, month + 1, 0)),
});

export const encodeMonth = (year: number, month: number): string =>
  `${year}-${pad(month + 1)}`;

export const decodeMonth = (value: string): MonthRange => {
  const [year, month] = value.split("-").map(Number);
  return monthRange(year, month - 1);
};

/**
 * Closed months only, most recent first - the current month is still
 * accumulating parcels, so its performance figures would be misleading.
 */
export const monthOptions = (today: Date = new Date()): SelectOption[] => {
  const options = [] as SelectOption[];

  for (let offset = 1; offset <= MONTHS_OFFERED; offset++) {
    const date = new Date(today.getFullYear(), today.getMonth() - offset, 1);
    options.push({
      value: encodeMonth(date.getFullYear(), date.getMonth()),
      label: `${MONTH_LABELS[date.getMonth()]} ${date.getFullYear()}`,
    });
  }

  return options;
};
